import * as React from 'react'

import { Box, Icon, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { ExplotableItem, ExplotableList } from 'modules/core/components/Explotable'
import SortableBoxList from 'modules/core/components/SortableBoxList'

import Header from 'modules/reviews/components/QuestionConfigs/Show/_Header/index'
import type QuestionConfig from 'modules/reviews/store/models/QuestionConfig'

import CustomField from '../List/Item/CustomField'

interface Props {
  filteredScoreQuestions: QuestionConfig[]
}

function RenderedScoreQuestions({ filteredScoreQuestions }: Props) {
  const [open, toggle] = useToggle(true)

  const questionsHeader = (open: boolean) => (
    <Header totalQuestions={filteredScoreQuestions.length} expanded={open} />
  )

  return (
    <ExplotableList>
      <ExplotableItem
        opened={open}
        toggle={toggle(!open)}
        renderCollectionHeader={() => questionsHeader(open)}
        fromCollection
        scrollLimited={false}
      >
        <>
          <SortableBoxList
            items={filteredScoreQuestions}
            onSortEnd={() => {}}
            itemAsKey={(item) => item.attributes.id}
            isDisabled={() => true}
            renderItem={(questionConfig) => (
              <Box flexDirection="row" paddingX="s16" flexGrow gap="s8">
                <Box paddingTop="s24" width="s12">
                  <Icon.Medium color="grey700" icon="lock-locked" />
                </Box>
                <Box padding="s24" gap="s8" flexGrow>
                  <CustomField customField={questionConfig.attributes.custom_field} />
                </Box>
              </Box>
            )}
            emptyMessage={''}
          />
        </>
      </ExplotableItem>
    </ExplotableList>
  )
}

export default observer(RenderedScoreQuestions)
